const actions = {
    CUSTOMER_DETAILS_START: 'CUSTOMER_DETAILS_START',
    CUSTOMER_DETAILS_SUCCESS: 'CUSTOMER_DETAILS_SUCCESS',
    CUSTOMER_DETAILS_FAILURE: 'CUSTOMER_DETAILS_FAILURE',

    SALES_SELFBILL_DETAILS_START: 'SALES_SELFBILL_DETAILS_START',
    SALES_SELFBILL_DETAILS_SUCCESS: 'SALES_SELFBILL_DETAILS_SUCCESS',
    SALES_SELFBILL_DETAILS_FAILURE: 'SALES_SELFBILL_DETAILS_FAILURE',

    CUSTOMER_PAYMNET_DETAILS_START: 'CUSTOMER_PAYMNET_DETAILS_START',
    CUSTOMER_PAYMNET_DETAILS_SUCCESS: 'CUSTOMER_PAYMNET_DETAILS_SUCCESS',
    CUSTOMER_PAYMNET_DETAILS_FAILURE: 'CUSTOMER_PAYMNET_DETAILS_FAILURE',

    STORE_SALES_DETAILS_START: 'STORE_SALES_DETAILS_START',
    STORE_SALES_DETAILS_SUCCESS: 'STORE_SALES_DETAILS_SUCCESS',
    STORE_SALES_DETAILS_FAILURE: 'STORE_SALES_DETAILS_FAILURE',

    CLEAR_MANAGEMENT_DETAILS_START: 'CLEAR_MANAGEMENT_DETAILS_START',
    CLEAR_MANAGEMENT_DETAILS_SUCCESS: 'CLEAR_MANAGEMENT_DETAILS_SUCCESS'

};

export default actions;